import { axios } from "utils";

export const getAllStatistics = () =>
    axios.get(`/statistics/total`).then((res) => res.data?.doc);